// Mirrors the backend's KeyEventRefType enum (Shared/Enums/Shared.cs) - ordinals must stay in sync.
export const KEY_EVENT_REF_TYPES = {
  PORTFOLIO: 0,
  PROGRAM: 1,
  PROJECT: 2,
  SCOPE: 3,
  TASK: 4,
};

export const KEY_EVENT_REF_TYPE_LABELS = {
  [KEY_EVENT_REF_TYPES.PORTFOLIO]: "Portfolio",
  [KEY_EVENT_REF_TYPES.PROGRAM]: "Program",
  [KEY_EVENT_REF_TYPES.PROJECT]: "Project",
  [KEY_EVENT_REF_TYPES.SCOPE]: "Scope",
  [KEY_EVENT_REF_TYPES.TASK]: "Task",
};

export const KEY_EVENT_TYPES = {
  TARGET_DATE: 0,
  DATE_RANGE: 1,
};

export const KEY_EVENT_ICON_TYPES = {
  CUSTOM: 0,
  MILESTONE: 1,
  DEADLINE: 2,
  REVIEW: 3,
};

// Which entityType owns Key Events (matches Timeline's entityType, not KEY_EVENT_REF_TYPES directly -
// "projectTimeline" is a frontend-only discriminator, its owner ref type on the wire is PROJECT).
export const OWNER_REF_TYPE_BY_ENTITY_TYPE = {
  portfolio: KEY_EVENT_REF_TYPES.PORTFOLIO,
  program: KEY_EVENT_REF_TYPES.PROGRAM,
  projectTimeline: KEY_EVENT_REF_TYPES.PROJECT,
};

// Allowed link ("attach to") depth per owner entityType - must mirror the backend's
// KeyEventService.AllowedLinkTypes table exactly.
export const ALLOWED_LINK_REF_TYPES_BY_ENTITY_TYPE = {
  portfolio: [KEY_EVENT_REF_TYPES.PROGRAM, KEY_EVENT_REF_TYPES.PROJECT],
  program: [KEY_EVENT_REF_TYPES.PROJECT, KEY_EVENT_REF_TYPES.SCOPE, KEY_EVENT_REF_TYPES.TASK],
  projectTimeline: [KEY_EVENT_REF_TYPES.SCOPE, KEY_EVENT_REF_TYPES.TASK],
};
